let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("87NAU")).then(() => parcelRequire('EHmU1'));